import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import getters from './getters'

// 注册Vuex
Vue.use(Vuex)

// 创建store实例
const store = new Vuex.Store({
  modules: {
    user // 用户模块
  },
  getters // 全局getters
})

export default store